import * as angular from 'angular';

import controller from './platform-header-nav-panel-controller';
import { DisplayMode } from '@mode/shared/contract-common';

const PlatformHeaderNavPanelComponent: angular.IComponentOptions = {
  controller,
  controllerAs: 'ctrl',
  bindings: {
    breakpoint: '<',
    menuType: '<',
    navDisplayMode: '<',
    onSimpleShare: '&?',
    editAccess: '<',
    isLocal: '<?',
    isNewDataset: '<?',
  },
  template: `
    <a class="platform-header-avatar-link"
      href="{{ ctrl.avatar.targetUrl }}"
      target="_self"
      rel="noopener noreferrer"
    >
      <mode-workspace-avatar
        [type]="ctrl.avatar.type"
        [initials]="ctrl.avatar.initials"
        [color-class]="ctrl.avatar.colorClass"
        [image-src]="ctrl.avatar.imageSrc"
        [image-name]="ctrl.avatar.name"
        [is-community]="ctrl.avatar.type === 'community'"
      ></mode-workspace-avatar>
    </a>

    <!-- Explore Nav Panel Container -->
    <nav ng-if="ctrl.showExploreHeader" class="platform-header-explore">
      <mode-breadcrumbs [breadcrumbs]="(ctrl.explorationBreadcrumbs$ | async:this)"></mode-breadcrumbs>

      <div class="non-breadcrumb-buttons" ng-switch="ctrl.$state.current.name">
        <div
          uib-dropdown
          dropdown-append-to-body
          class="edit-delete-menu-container"
          ng-switch-when="explorationShow.edit">
          <button
            class="edit-delete-menu-btn"
            uib-dropdown-toggle
            ng-class="{ 'active': ctrl.editDeleteMenuOpen }">
            <i class="icon-gear-outlined-default align-md-icon md-icon icon-default"></i>
          </button>
          <ul uib-dropdown-menu class="dropdown-menu">
            <li>
              <a href="#" ng-click="ctrl.handleEditExplorationModal()">Rename...</a>
            </li>
            <li>
              <a href="#" ng-click="ctrl.handleEditExplorationModal()">Edit description...</a>
            </li>
            <li class="divider"></li>
            <li>
              <a href="#" ng-click="ctrl.handleDeleteExplorationModal()">Delete Exploration...</a>
            </li>
          </div>
        </div>

        <!-- Header for Explore Mode --->
        <div
          ng-switch="ctrl.$state.current.name"
          class="button-group"
        >

          <capra-tooltip
            [tooltip-content]="'Copy to ' + ctrl.appName + ' clipboard'"
            tooltip-placement="bottom"
            tooltip-size="mini">
            <capra-icon-button
              class="copy-exploration dark"
              icon="icon-copy-chart"
              (clicked)="ctrl.copyExploration()"
            ></capra-icon-button>
          </capra-tooltip>

          <capra-button
            ng-if="(ctrl.$state.includes('**.explore') && ctrl.$state.includes('reportShow')) || ctrl.$state.includes('**.pythonviz.view') || ctrl.$state.includes('reportShow.noRuns.viz') || ctrl.$state.includes('reportShow.runs.viz')"
            ui-sref="{{ ctrl.buildUiSref('.dashboard', { vizId: null }) }}"
            text="Back to report"
            variant="secondary"
            color="neutral-light"
            icon="icon-back"
            (clicked)="ctrl.handleBackToReport()"
          ></capra-button>

          <capra-tooltip
            ng-if="ctrl.allowedToExplore$ | async:this"
            ng-switch-when-separator="|"
            ng-switch-when="explorationShow.explore|reportShow.noRuns.chart.explore|reportShow.runs.chart.explore|reportShow.noRuns.pythonviz.explore|reportShow.runs.chart.explore"
            [tooltip-content]="ctrl.saveExplorationToolTipCopy"
            tooltip-placement="bottom"
            [tooltip-is-disabled]="ctrl.isLocal"
            [tooltip-content-is-html]="true"
            size="mini"
          >
            <capra-button
              data-test="save-exploration"
              text="Save Exploration"
              [disabled]="!ctrl.isLocal"
              (clicked)="ctrl.openSaveExplorationModal()"
            ></capra-button>
          </capra-tooltip>

          <capra-button
            text="Share"
            variant="secondary"
            color="neutral-light"
            icon="icon-link"
            copy-to-clipboard
            ng-switch-when-separator="|"
            ng-switch-when="explorationShow.edit|explorationShow.focus"
            clipboard-text="ctrl.shareLink"
            clipboard-success="ctrl.copySuccess()"
          ></capra-button>

          <capra-button ng-if="ctrl.isExplorationOwner$ | async"
            ui-sref="explorationShow.explore({explorationId: ctrl.$state.params.explorationId, skipLoad: true})"
            text="New Exploration"
            variant="secondary"
            color="neutral-light"
            ng-switch-when-separator="|"
            ng-switch-when="explorationShow.edit|explorationShow.focus"
            (clicked)="ctrl.trackNewExplorationButtonClicked()"
          ></capra-button>
          <capra-button ng-if="!(ctrl.isExplorationOwner$ | async)"
            ui-sref="explorationShow.explore({explorationId: ctrl.$state.params.explorationId, skipLoad: true})"
            text="New Exploration"
            ng-switch-when-separator="|"
            ng-switch-when="explorationShow.edit|explorationShow.focus"
            (clicked)="ctrl.trackNewExplorationButtonClicked()"
          ></capra-button>

          <capra-button
            ui-sref="explorationShow.focus({explorationId: ctrl.$state.params.explorationId})"
            ng-switch-when="explorationShow.edit"
            text="View"
          ></capra-button>

          <capra-button ng-if="ctrl.isExplorationOwner$ | async"
            ui-sref="explorationShow.edit({explorationId: ctrl.$state.params.explorationId})"
            ng-switch-when="explorationShow.focus"
            text="Edit"
          ></capra-button>

          <div
            uib-dropdown
            dropdown-append-to-body
            ng-switch-when-separator="|"
            ng-switch-when="explorationShow.edit|explorationShow.focus"
            class="kebab-menu-container">

            <button
              class="kebab-menu-btn"
              uib-dropdown-toggle>
              <svg-icon type="'kebab'" class="explore-nav-btn-icon"></svg-icon>
            </button>

            <ul uib-dropdown-menu  class="dropdown-menu-right">
              <li menu-item="exp">
                <a ui-sref="reportShow.noRuns.detailsView.detailsQuery({reportId: ctrl.$state.params.reportId, account: ctrl.$state.params.account, queryId: (ctrl.activeExplorationQueryToken$ | async:this)})" target="_blank">
                  View source code
                </a>
              </li>
              <li menu-item="exp">
                <a ui-sref="reportShow.noRuns.detailsView.detailsDataset({reportId: ctrl.$state.params.reportId, account: ctrl.$state.params.account, queryId: (ctrl.activeExplorationQueryToken$ | async:this)})" target="_blank">
                  View raw data
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
    <!-- End Explore Nav panel -->

    <!-- Datasets Nav Panel Container -->
    <nav ng-if="ctrl.showDatasetsHeader" class="platform-header-datasets" ng-class="{'studio-enabled': (ctrl.modeStudioEnabled$ | async:this), 'analyst-studio': (ctrl.isAnalystStudio$ | async:this)}">
      <div class="platform-header-breadcrumbs datasets-breadcrumbs">
        <mode-breadcrumbs [breadcrumbs]="(ctrl.breadcrumbs$ | async:this)">
          <mode-dataset-publish-badge
            mode-breadcrumbs-name-prefix
            ng-show="ctrl.isDatasetPublished$ | async:this"
            class="publish-dataset"
            [publisher]="(ctrl.datasetPublication$ | async:this).publisher"
            [publisher-username]="(ctrl.datasetPublication$ | async:this).publisherUsername"
            [published-at]="(ctrl.datasetPublication$ | async:this).publishedAt"
            [publish-url]="(ctrl.datasetPublication$ | async:this).publishUrl"
          ></mode-dataset-publish-badge>
        </mode-breadcrumbs>


        <!-- Dirty state flag -->
        <div class="platform-header-dirty-state" ng-if="ctrl.reportSaveService.reportHasChanged()">
          <div class="dirty-flag"
            uib-tooltip-html="'There are unsaved changes.<br />Ctrl/Cmd-S to save.'"
            tooltip-append-to-body="true"
            tooltip-placement="bottom"></div>
        </div>
        <mode-dataset-header-dropdown
          data-test="dataset-dropdown"
          [dataset-token]="ctrl.$state.params.reportId"
          [is-dirty]="ctrl.reportSaveService.reportHasChanged()"
          [is-disabled]="!(ctrl.reportRun$ | async:this)"
          [dataset-share-link]="ctrl.datasetsShareLink"
          [mode-studio-enabled]="ctrl.featureToggleService.featureModeStudioEnabled$ | async: this"
          [is-personal]="ctrl.isPersonal"
          [show-go-to-data-workspace]="ctrl.canDatasetRepublish$ | async:this"
          [thoughtspot-data-workspace-link]="ctrl.thoughtspotDataWorkspaceLink"
          [publish-option]="(ctrl.datasetQueryRunSucceeded$ | async:this) ? (ctrl.publishOptionCTA$ | async:this) : null"
          (click-save)="ctrl.handleSave()"
          (dataset-deleted)="ctrl.navigateToCollection((ctrl.collectionUrl$ | async:this))"
          (navigate-to-dataset)="ctrl.navigateToDatasetViewPage()"
          (click-use-in-new-report)="ctrl.createNewReportWithDataset()"
          (publish-option-clicked)="ctrl.publishOptionClicked($event, 'Header Dropdown')"
        >
          <!-- Start transcluded content -->
          <div class="move-space" move-space account="ctrl.account$ | async:this", owner="ctrl.reportOwnerWithSpaces$ | async:this", report="ctrl.report$ | async:this"  on-report-space-update="ctrl.handleDatasetReportSpaceTransfer($space, isViaPublishAction, switchViewToken)" data-test="move-dataset">
            Move to...
          </div>
          <div class="rename-report" rename-report is-report-state="ctrl.reportStateEnabled$ | async:this" is-dataset-published="ctrl.isDatasetPublished$ | async:this" report="ctrl.report$ | async:this" is-dataset="true">
            Rename...
          </div>
          <div manage-schedule
             schedules-modal
             report="ctrl.report$ | async:this"
             report-run="ctrl.reportRun$ | async:this"
             account="ctrl.account$ | async:this"
             owner="ctrl.orgContext$ | async:this">
             Schedule...
          </div>
          <!-- End transcluded content -->
        </mode-dataset-header-dropdown>

        <mode-github-sync-indicator
          ng-if="ctrl.canSyncToGithub$ | async:this"
          class="github-sync-indicator"
          [last-synced-at]="ctrl.lastSyncedAt$ | async:this"
          [has-unsynced-changes]="ctrl.hasUnsyncedChanges$ | async:this"
          content-type="Dataset"
          github-sync-menu-name="More">
        </mode-github-sync-indicator>
      </div>

      <div class="non-breadcrumb-buttons">
        <capra-tooltip
          ng-if="(ctrl.showShareButton$ | async:this)"
          [tooltip-content]="(ctrl.reportRun$ | async:this) ? 'Copy Dataset link' : 'Run the Dataset to copy its share link'"
          tooltip-placement="bottom"
        >
          <capra-button
            ng-if="ctrl.isDatasetPublished"
            [disabled]="!(ctrl.reportRun$ | async:this)"
            text="Share"
            size="small"
            variant="secondary"
            color="neutral-light"
            icon="icon-link"
            copy-to-clipboard
            clipboard-text="ctrl.datasetsShareLink"
            clipboard-success="ctrl.copyDatasetSuccess()"
          ></capra-button>
        </capra-tooltip>
        <capra-tooltip
          [tooltip-content]="'Run the Dataset to view its results'"
          tooltip-placement="bottom"
          [tooltip-is-disabled]="ctrl.isDatasetPublished === 'Preview' || (ctrl.reportRun$ | async:this)"
        >
          <capra-button
            [disabled]="!(ctrl.reportRun$ | async:this)"
            [text]="ctrl.isDatasetPublished ? 'View' : 'Preview';"
            size="small"
            variant="secondary"
            color="neutral-light"
            (clicked)="ctrl.navigateToDatasetViewPage()"
            data-test="view-button"
          >
          </capra-button>
        </capra-tooltip>
        <capra-tooltip
          [tooltip-content]="'Run the Dataset to use its data in a new Report'"
          tooltip-placement="bottom"
          [tooltip-is-disabled]="(ctrl.reportRun$ | async:this)"
        >
          <capra-button
            [disabled]="!(ctrl.reportRun$ | async:this)"
            color="{{ (ctrl.canPublishDataset$ | async:this) || ctrl.isPersonal || !(ctrl.reportRun$ | async:this) ? 'neutral-light' : 'default' }}"
            text="Use in new Report"
            size="small"
            variant="{{ (ctrl.canPublishDataset$ | async:this) || ctrl.isPersonal || !(ctrl.reportRun$ | async:this) ? 'secondary' : 'primary' }}"
            (clicked)="ctrl.createNewReportWithDataset()"
            icon="icon-plus-default"
            data-test="use-in-new-report"
          ></capra-button>
        </capra-tooltip>
        <capra-tooltip
          ng-if="(ctrl.isPersonal || (ctrl.isNewDataset && !(ctrl.reportRun$ | async:this))) && !(ctrl.canDatasetRepublish$ | async:this)"
          [tooltip-content]="(ctrl.reportRun$ | async:this) ? 'Move to a Workspace Collection to make the data discoverable by other members' : 'Run the Dataset to move it to a Collection' "
          tooltip-placement="bottom"
        >
          <capra-button
            ng-if="(ctrl.isPersonal || (ctrl.isNewDataset && !(ctrl.reportRun$ | async:this))) && !(ctrl.canDatasetRepublish$ | async:this)"
            [disabled]="!(ctrl.reportRun$ | async:this)"
            data-test="move-to-new-collection"
            move-space
            text="Move to a Collection"
            size="small"
            color="{{ (ctrl.canPublishDataset$ | async:this) ? 'neutral-light' : 'default' }}"
            variant="{{ (ctrl.canPublishDataset$ | async:this) ? 'secondary' : 'primary' }}"
            icon="icon-collection"
            account="ctrl.account$ | async:this"
            owner="ctrl.reportOwnerWithSpaces$ | async:this"
            report="ctrl.report$ | async:this"
            on-report-space-update="ctrl.handleDatasetReportSpaceTransfer($space, isViaPublishAction, switchViewToken)"
          ></capra-button>
        </capra-tooltip>
        <capra-tooltip
        ng-if="(ctrl.canPublishDataset$ | async:this)"
        [tooltip-content]="(ctrl.reportRun$ | async:this) ? 'Publish this Dataset to import it as a table in the data workspace': 'Run the Dataset to publish it to the Data Workspace'"
        tooltip-placement="bottom"
        >
          <capra-button
            [disabled]="!(ctrl.datasetQueryRunSucceeded$ | async:this)"
            color="default"
            text="Publish"
            size="small"
            (clicked)="ctrl.openDatasetPublishModal('Header CTA')"
            data-test="publish-dataset-cta"
          ></capra-button>
        </capra-tooltip>
        <capra-tooltip
        ng-if="(ctrl.canDatasetRepublish$ | async:this)"
        [tooltip-content]="'Push the latest set of changes to the corresponding table in the Data Workspace'"
        tooltip-placement="bottom"
        >
          <capra-button
            color="default"
            text="Republish"
            size="small"
            (clicked)="ctrl.openRepublishDatasetModal('Header CTA')"
            data-test="re-publish-dataset-cta"
          ></capra-button>
        </capra-tooltip>
      </div>
    </nav>

    <!-- Full Nav Panel Container-->
    <div class="platform-header-nav-container full"
         ng-if="!ctrl.showExploreHeader && !ctrl.showDatasetsHeader">
      <div
        class="header-breadcrumbs platform-header-breadcrumbs"
        ng-class="{'mobile-breadcrumbs':(ctrl.navDisplayMode === '${DisplayMode.Dropdown}')}"
      >
        <mode-breadcrumbs
          [breadcrumbs]="(ctrl.breadcrumbs$ | async:this)"
          [display-mode]="ctrl.navDisplayMode"
          (breadcrumb-clicked)="ctrl.handleBreadcrumbClick($event)"
        >
        <capra-badge
            mode-breadcrumbs-name-prefix
            ng-show="ctrl.isReportArchived$ | async:this"
            class="breadcrumb-badge"
            text="ARCHIVED"
            data-test="archived-breadcrumb-badge"
            type="dark-gray"
          ></capra-badge>
        </mode-breadcrumbs>
      </div>

      <!-- Platform Header Badges -->
      <div class="platform-header-badges"
        ng-if="ctrl.sharingBannerHidden$ | async:this">
        <a class="header-badge"
           ng-if="ctrl.reportIsExternal$ | async:this"
           ng-click="ctrl.handleExternalBadgeClick($event)" >
          <i class="icon-ext-share-small"></i>
          <span class="header-badge--text">External</span>
        </a>
      </div>

      <!-- Dirty state flag -->
      <div class="platform-header-dirty-state" ng-if="ctrl.reportSaveService.reportHasChanged()">
        <div class="dirty-flag"
          uib-tooltip-html="'There are unsaved changes.<br />Ctrl/Cmd-S to save.'"
          tooltip-append-to-body="true"
          tooltip-placement="bottom"></div>
      </div>

      <!-- Report star -->
      <div class="platform-header-star" ng-if="ctrl.starOption && ctrl.starOption.isGranted()">
        <mode-star
          [highlighted]="ctrl.reportUserStar$ | async:this"
          (highlighted-changed)="ctrl.toggleReportUserStar()"
          data-test="star-report">
        </mode-star>
      </div>

      <platform-header-nav
        account="ctrl.account$ | async:this"
        options="ctrl.menuOptions$ | async:this"
        default-commit-message-text="ctrl.defaultCommitMessageText$ | async:this"
        expected-runtime="ctrl.expectedRuntime$ | async:this"
        has-unsynced-changes="ctrl.reportSaveService.reportHasChanged() || (ctrl.hasUnsyncedChanges$ | async:this)"
        has-unsaved-changes="ctrl.reportSaveService.reportHasChanged()"
        last-synced-at="ctrl.lastSyncedAt$ | async:this"
        mobile-menu-is-open="ctrl.mobileMenuIsOpen"
        nav-type="ctrl.menuType"
        display-mode="ctrl.navDisplayMode"
        on-definition-created="ctrl.handleDefinitionCreated($redirectLink)"
        on-definition-update="ctrl.handleDefinitionUpdate($definitionModel)"
        on-definition-delete="ctrl.handleDefinitionDelete()"
        on-mobile-menu-toggle="ctrl.handleMobileMenuToggle($isOpen)"
        on-report-space-transfer="ctrl.handleReportSpaceTransfer($space, isViaPublishAction, switchViewToken)"
        on-run-report="ctrl.handleRunReport()"
        on-report-deleted="ctrl.handleReportDeleted($reportToken)"
        on-view-details="ctrl.handleViewDetails()"
        on-view-report="ctrl.handleViewReport()"
        on-simple-share="ctrl.handleSimpleShare()"
        on-save-click="ctrl.handleSave()"
        organizations="ctrl.orgs$ | async:this"
        owner="ctrl.orgContext$ | async:this"
        report="ctrl.report$ | async:this"
        report-run="ctrl.reportRun$ | async:this"
        report-run-at="ctrl.reportRunAt$ | async:this"
        report-space="ctrl.reportSpace$ | async:this"
        selected-definition="ctrl.selectedDefinition$ | async:this"
        share-dialog-data$="ctrl.shareDialogData$"
        stale-run-at-enabled="ctrl.modeStudioEnabled$ | async:this"
        dbt-data="ctrl.reportDbtData$ | async:this"
        dbt-data-loading="ctrl.reportDbtDataLoading$ | async:this"
        referenced-datasources="ctrl.referencedDatasources$ | async:this"
        edit-access="ctrl.editAccess"
        dataset-last-refreshed="ctrl.datasetLastRefreshed$ | async:this"
        dataset-count="ctrl.dataViewFacade.importedDatasetCount$ | async:this"
      />
    </div>
  `,
};

export { PlatformHeaderNavPanelComponent };
